// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4":"fd7dc6da0d57a5fe","65":"0c5d135613753f63","121":"77aca2cd06a9e50b","141":"624bde59ebd3f28e","329":"f494f260df295a74","394":"ccc700d0510dd8fd"}[chunkId] + ".js";
};